//
import PurchaseInvoiceModel from '@/models/Purchase/PchPurchaseInvoice'
import ProviderAccountBankModel from '@/models/Purchase/PchProviderAccountBank'
import UserModel from '@/models/General/GUser'

//
import DetailProviderPaymentSheetHeaders from '@/views/Purchase/PchProviderPaymentSheet/partials/DetailProviderPaymentSheetHeaders'

//
import PurchaseInvoiceFilters from '@/views/Purchase/PchPurchaseInvoice/partials/PurchaseInvoiceFilters'
import PurchaseInvoiceHeaders from '@/views/Purchase/PchPurchaseInvoice/partials/PurchaseInvoiceHeaders'

//
export default props => [
    {
        name: 'g_user_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'hr_employee_full_name',
            itemValue: 'id',
            label: 'Responsable',
            model: UserModel,
            noObject: true,
            readonly: true,
        },
    },
    {
        name: 'payment_date',
        type: 'date-field',
        props: {
            label: 'Fecha de pago',
        },
        trigger: props.payment_date_trigger,
    },
    {
        name: 'selected',
        type: 'table-field',
        flex: {
            'd-grid': true,
            xs12: true,
        },
        props: {
            headers: DetailProviderPaymentSheetHeaders,
            noDataText: 'Sin documentos por pagar.',
            pickerProps: {
                filters: PurchaseInvoiceFilters,
                headers: PurchaseInvoiceHeaders,
                initialFilterValues: {
                    payment_date: props.selected_payment_date,
                },
                noDataText: 'Sin documentos pagables pendientes.',
                paramFilter: {
                    payable: true,
                    //payment_date: props.selected_payment_date,
                    not_in_payment_sheet: true,
                },
                paramSearch: 'invoice_number',
                service: PurchaseInvoiceModel,
                title: 'Seleccionar documento a pagar',
            },
            toolbarTitle: 'Listado de facturas',
            showPicker: true,
        },
        trigger(ctx) {
            ctx.value.selected.forEach(e => {
                if (!e.pch_provider_account_bank_id) {
                    // getting account bank
                    ProviderAccountBankModel
                        .include('g_bank')
                        .where('pch_provider_id', e.pch_provider_id)
                        .get()
                        .then(({ data }) => {
                            e.pch_provider_account_bank = data.slice().pop()
                            //console.log()
                            ctx.$refs.fieldset.$forceUpdate()
                        })

                    // setting waiting account bank
                    e.pch_provider_account_bank = {
                        id: 1,
                        account_number: 'Cargando cuenta...',
                        g_bank: {
                            bank: 'Cargando cuenta...',
                        },
                    }
                }
            })
        },
    },
    {
        name: 'selected_total',
        type: 'currency-field',
        props: {
            label: 'Total',
            readonly: true,
            reverse: true,
        },
    },
]
